import styled from "styled-components";

import {
    colors
}

    from "../common/element/elements.js";

export const Styles = styled.div` .service-area {
    padding: 56px 0 42px;

    .sec-title {
        h4 {
            color : $ {
                colors.blue
            }

            ;
            line-height : 35px;
            font-weight : 600;
            max-width : 950px;
            margin : auto;
            margin-bottom: 40px;

            @media(max-width: 575px) {
                margin-bottom: 15px;
                font-size: 20px;
            }
        }
    }

    .service-box {
        padding: 35px 20px 20px;
        box-shadow: 0 12px 25px rgba(0, 0, 0, 0.07);
        border-radius: 5px;
        margin-bottom: 30px;

        .box-icon {
            background : $ {
                colors.blue
            }

            ;
            height : 36px;
            text-align : center;
            margin-right: 20px;
            position : relative;

            i {
                font-size: 34px;
                color: #ffffff;
                width: 60px;
                display: inline-block;
                position: relative;
                z-index: 111;
                margin-top: -8px;

                @media(max-width: 991px) {
                    font-size: 24px;
                    width: 45px;
                }

                @media(max-width: 767px) {
                    font-size: 34px;
                    width: 60px;
                }
            }

            &::before {
                content: "";
                position: absolute;
                border-width: 15px 30px;
                border-style: solid;
                border-top-color: transparent;
                border-right-color: transparent;

                border-bottom-color: $ {
                    colors.blue
                }

                ;
                border-left-color : transparent;
                top : -30px;
                left : 0;
                z-index : 1;

                @media(max-width: 991px) {
                    border-width: 12px 23px;
                    top: -24px;
                }

                @media(max-width: 767px) {
                    border-width: 15px 30px;
                    top: -30px;
                }
            }

            &:after {
                content: "";
                position: absolute;
                border-width: 15px 30px;
                border-style: solid;

                border-top-color : $ {
                    colors.blue
                }

                ;
                border-right-color : transparent;
                border-bottom-color: transparent;
                border-left-color : transparent;
                bottom : -30px;
                left : 0;
                z-index : 1;

                @media(max-width: 991px) {
                    border-width: 12px 23px;
                    bottom: -24px;
                }

                @media(max-width: 767px) {
                    border-width: 15px 30px;
                    bottom: -30px;
                }
            }

            @media(max-width: 991px) {
                height: 22px;
                margin-right: 10px;
            }

            @media(max-width: 767px) {
                height: 36px;
                margin-right: 20px;
            }
        }

        .box-title {
            margin-top: -15px;

            h6 {
                color : $ {
                    colors.black1
                }

                ;
                text-transform: uppercase;
                font-weight : 600;
                margin-bottom : 6px;

                @media(max-width: 991px) {
                    font-size: 13px;
                    letter-spacing: 0;
                }

                @media(max-width: 767px) {
                    font-size: 16px;
                    letter-spacing: 0.3px;
                }

                @media(max-width: 575px) {
                    font-size: 15px;
                }
            }

            p {
                font-size: 14px;

                color : $ {
                    colors.text3
                }

                ;

                @media(max-width: 991px) {
                    font-size: 13px;
                    letter-spacing: 0;
                }

                @media(max-width: 767px) {
                    font-size: 14px;
                    letter-spacing: 0.3px;
                }
            }
        }

        @media(max-width: 991px) {
            padding: 25px 10px 8px;
        }

        @media(max-width: 767px) {
            padding: 35px 20px;
            margin-bottom: 25px;
        }
    }

    @media(max-width: 767px) {
        padding: 30px 0 15px;
    }
}


body {
    padding-top: 3rem;
    padding-bottom: 3rem;
    color: #5a5a5a;
    font-family: 'Poppins', sans-serif !important;
}

.navbar {
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
}

.carousel-indicators {
    margin: 50px auto;
    background: #fff;
    width: 200px;
    border-radius: 50px;
    min-height: 55px;
    align-items: center;
}

.carousel-indicators [data-bs-target] {
    width: 18px;
    height: 18px;
    border: 1px solid #2C79FF;
    border-radius: 50%;
}

.carousel-indicators .active {
    background: #2C79FF;
}


.why-Visualpath:before {
    background: url(../../images/circle-bg.svg) no-repeat top center;
    width: 100%;
    height: 1354px;
    content: '';
    position: absolute;
    top: -735px;
    left: 0;
    z-index: -1;

}

.why-Visualpath:after {
    background: url(../assets/images/fundamentals-bg.jpg) no-repeat top center;
    width: 100%;
    height: 1354px;
    content: '';
    position: absolute;
    top: -720px;
    left: 0;
    z-index: -2;

}

.main-title {
    font-size: 40px;
    font-weight: 600;
    color: #2C79FF;
    margin-bottom: 20px;
    text-decoration: underline;
}

.description {
    font-size: 16px;
    color: #494949;
    margin-bottom: 40px;
}

.why-Visualpath .col-block>div {
    //   border:1px solid #EAEAEA;
    //   border-radius:50%;
    width: 110px;
    height: 110px;
    background: #fff;
    display: block;
    //   margin:0 auto;
    display: flex;
    align-items: center;
    justify-content: Center;
    margin-bottom: 10px;
}

.why-Visualpath .col-block h4 {
    font-size: 22px;
    font-weight: 600;
    line-height: 33px;
    color: #494949
}

.why-Visualpath .col-block h4 span {
    color: #494949;
    font-weight: 500;
    display: block;
}

//   .line0{margin-top:10%;position:absolute;left:-25%; } 
//   .line1{margin-top:10%;position:absolute;left:-20px;} 
//   .line2{margin-top:10%;position:absolute;left: 20%; }
.line3 {
    margin-top: 25%;
    position: absolute;
    left: -30%;
}

.line4 {
    margin-top: 25%;
    position: absolute;
    left: -10px;
}

.line5 {
    margin-top: 25%;
    position: absolute;
    left: 30%;
}


.plans-main-block {
    padding: 80px 0;
}

.plan-block {
    //   background:linear-gradient(0deg, rgba(44, 121, 255, 0.95), rgba(44, 121, 255, 0.8)), url(../../images/4th-year.jpg);
    border-radius: 5px 50px;
    min-height: 200px;
    display: flex;
    align-items: Center;
    justify-content: Center;
    font-size: 26px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    //   box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
    margin-bottom: 25px;
    transition: 2s ease all;
    text-align: center;
    //    background-image: url("%3Csvg width='243' height='267' viewBox='0 0 243 267' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M101.5 5.547C113.876 -1.59831 129.124 -1.59831 141.5 5.547L222.311 52.203C234.687 59.3483 242.311 72.5534 242.311 86.844V180.156C242.311 194.447 234.687 207.652 222.311 214.797L141.5 261.453C129.124 268.598 113.876 268.598 101.5 261.453L20.6895 214.797C8.31341 207.652 0.689453 194.447 0.689453 180.156V86.844C0.689453 72.5534 8.31341 59.3483 20.6895 52.203L101.5 5.547Z' fill='%23007CC1'/%3E%3C/svg%3E%0A");
    background-image: url("data:image/svg+xml,%3Csvg width='243' height='267' viewBox='0 0 243 267' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M101.5 5.547C113.876 -1.59831 129.124 -1.59831 141.5 5.547L222.311 52.203C234.687 59.3483 242.311 72.5534 242.311 86.844V180.156C242.311 194.447 234.687 207.652 222.311 214.797L141.5 261.453C129.124 268.598 113.876 268.598 101.5 261.453L20.6895 214.797C8.31341 207.652 0.689453 194.447 0.689453 180.156V86.844C0.689453 72.5534 8.31341 59.3483 20.6895 52.203L101.5 5.547Z' fill='%23007CC1'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: center center;
    width: 243px;
    height: 267px;
    margin: 0 auto;
}


.years {
    padding: 20px;
    width: 95%;
    text-align: center;
    box-shadow: 0 6px 15px rgba(126, 121, 121, 0.3);
    border-radius: 2px 40px 2px 40px;
    transition: transform 0.3s ease-in-out, box-shadow 0.3s;
    color: white;
    background: linear-gradient(85deg, #928f77, #8e8962);
    display: inline-grid;
    align-content: center;
    height: 200px;
    overflow: hidden;
}

.years:hover {
    transform: scale(1.1);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

// .years::before {
//     content: '';
//     position: absolute;
//     top: -50px;
//     left: -50px;
//     width: 150px;
//     height: 150px;
//     background: rgba(255, 255, 255, 0.3);
//     border-radius: 50%;
//     transition: transform 0.5s;
// }


.years:hover::before {
    transform: scale(1.5);
}

.years .h3 {
    align-items: center;
    font-size: 30px;
    font-weight: bold;

    margin-bottom: 10px;
}

.years .p {
    align-items: center;
    font-size: 20px;
}




.plan-block:hover {
    //   background:linear-gradient(0deg, rgba(44, 121, 255, 0.6), rgba(44, 121, 255, 0.7)), url(../../images/4th-year.jpg);
    //    -webkit-transition: background 1000ms linear;
    //   -ms-transition: background 1000ms linear;
    //   transition: background 1000ms linear;
    transform: scale(1.15);
}

.plan-block sup {
    margin-right: 10px;
}

.bg-blue {
    background: #fbfbfb;
    padding: 100px 0;
    position: relative;
}

/*
  .bg-blue:after{
      content: '';
      position: absolute;
      top: -36px;
      width: 55%;
      height: 212px;
      background: #ffffff;
      border-radius: 50%;
      z-index: -1;
      left: 50%;
      box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
      margin-left: -27.5%;
  }
  .bg-blue:before{
      content: '';
      position: absolute;
      bottom: -36px;
      width: 55%;
      height: 212px;
      background: #ffffff;
      border-radius: 50%;
      z-index: -1;
      left: 50%;
      box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
      margin-left: -27.5%;
  }*/

.state-block {
    text-align: Center;
    cursor: pointer;
}

.state-block .img-icon {
    width: 90px;
    height: 90px;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04);
    border-radius: 2px 20px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
}

.state-block span {
    display: block;
    font-weight: 500;
    font-size: 18px;
}



.nav-pills-custom .nav-link {
    color: #727272;
    background: #fff;
    position: relative;
    box-shadow: 0 .1rem 0.8rem rgba(0, 0, 0, .10) !important;
    padding: 10px;
    margin-bottom: 8px;
}

.nav-pills-custom .nav-link.active {
    color: #2C79FF;
    background: #fff;
    font-weight: 500;
}

.tab-content-custom>.tab-pane {
    min-height: 355px;
}

.custom-form-select {
    border: 1px solid #2C79FF;
    color: #2C79FF;
}


/* Add indicator arrow for the active tab */
@media (min-width: 992px) {
    .nav-pills-custom .nav-link::before {
        content: '';
        display: block;
        border-top: 8px solid transparent;
        border-left: 10px solid #fff;
        border-bottom: 8px solid transparent;
        position: absolute;
        top: 50%;
        right: -10px;
        transform: translateY(-50%);
        opacity: 0;
    }
}

.nav-pills-custom .nav-link.active::before {
    opacity: 1;
}



@media (max-width: 1500px) {

    .plans-main-block,
    .bg-blue {
        padding: 50px 0;
    }

    .carousel-indicators {
        margin: 14px auto 38px auto;
        min-height: 35px;
        width: 125px;
    }

    .carousel-indicators [data-bs-target] {
        width: 12px;
        height: 12px;
    }
}



@media (max-width: 767px) {
    body {
        margin-top: 5rem;
    }

    .carousel-indicators {
        margin: 14px auto;
        min-height: 35px;
        width: 160px;
    }

    .carousel-indicators [data-bs-target] {
        width: 12px;
        height: 12px;
    }
}

.fundamentals {
    font-size: 22px;
    font-weight: 600;
    line-height: 33px;
    color: #494949
}



//   --------------------------------------------

.why-Visualpath {
    padding: 0 0px;
    margin: 0;

    .educational-heading {
        text-align: center;

        h1 {
            margin-top: 25px;
            font-size: 35px;
            font-weight: 600;
            letter-spacing: .35px;
            text-decoration: underline;
            color: #4e4e4e;
        }

        p {
            font-size: 18px;
            color: #4e4e4e;
        }

        @media (max-width: 1340px) {
            h1 {
                font-size: 25px;
            }

            p {
                font-size: 14px;
            }
        }


        @media (max-width: 767px) {
            h1 {
                font-size: 22px;
                margin-bottom: 10px;
            }

            p {
                font-size: 14px;
            }
        }

    }

    .row {
        .card {
            box-shadow: 0px 0px 10px lightgrey;
            border-radius: 10px 50px 0px 50px;
            box-shadow: 0px 0px 10px rgb(255, 222, 151);
            border: 1px solid rgb(255, 222, 151);
            display: flex;
            align-items: center;
            justify-content: center;
            height: 250px;
            width: 100%;

            .card-content {
                img {
                    width: 100%;
                    object-fit: cover;
                }

            }

            .right {
                justify-content: center;
                padding: 10px;
                display: flex;
                flex-direction: column;

                .card-title {
                    font-size: 20px;
                    font-weight: bold;
                    letter-spacing: .25px;
                    font-style: italic;
                    text-decoration: underline;
                    color: rgba(175, 128, 8, 0.92);
                    // text-shadow: 1px 2px 3px rgba(243, 243, 243, 0.36);
                }

                .card-text {
                    font-size: 14px;
                    width: 100%;
                    font-family: system-ui;
                    color: rgb(31, 31, 66);
                }

                .btn {
                    background: rgb(245, 174, 31);
                    color: rgba(255, 255, 255, 0.91);
                    font-weight: 600;
                    padding: 8px 20px;
                    align-items: center;
                    font-size: 18px;
                    /* text-shadow: 1px 2px 3px white; */
                    box-shadow: 0px 2px 5px rgba(102, 101, 101, 0.86);
                    flex-direction: column;
                    margin-top: 20px;
                    /* align-self: flex-start; */
                    border: none;
                }

                .btn:hover {
                    background: rgb(255, 183, 0);
                    // transform: scale(.95);
                    color: rgb(36, 36, 36);
                    box-shadow: 0px 0px 8px rgba(75, 75, 75, 0.86);
                    transition: .5s;
                }

            }

            @media (max-width: 1340px) {
                height: 200px;
                border-radius: 5px 30px 5px 30px;
                margin-bottom: 20px;

                .right {
                    padding: 10px;
                    display: flex;

                    .card-title {
                        font-size: 18px;
                    }

                    .card-text {
                        font-size: 12px;
                    }

                    .btn {
                        padding: 5px;
                        align-items: center;
                        font-size: 14px;
                        margin-top: 10px;
                    }
                }
            }

            @media (max-width: 991px) and (min-width: 768px) {
                height: 250px;

                .right {
                    padding: 5px;

                    .card-title {
                        font-size: 16px;
                    }

                    .card-text {
                        font-size: 12px;
                    }
                }
            }
        }

        .card:hover {
            border: none;
            box-shadow: 0px 0px 10px rgba(0, 69, 230, 0.415);
            transform: scale(.98);
        }

    }

}

.card-scrolling {
    position: relative;
    padding: 20px;
    margin-top: 0px;
    margin-bottom: 0;

    h1 {
        font-size: 30px;
        text-decoration: underline;
    }

    .card-wrapper {
        display: flex;
        gap: 15px;
        overflow-x: auto;
        scroll-behavior: smooth;
        scrollbar-width: none;
        white-space: nowrap;
    }

    .card-wrapper::-webkit-scrollbar {
        display: none;
    }

    .card {
        min-width: 500px;
        height: 300px;
        background: rgba(252, 240, 130, 0.667);
        display: flex;
        justify-content: center;
        /* align-items: center; */
        font-size: 20px;
        border-radius: 10px;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
        overflow: hidden;


        a img {
            width: 100%;
            min-width: 500px;
            height: 300px;
            object-fit: cover;
            cursor: pointer;
        }

    }

    .card:hover {
        transform: scale(.95);
        transition: .5s;
    }

    // /* Arrow Button Styles */
    .arrow {
        position: absolute;
        transform: translateY(-50%);
        background: rgba(0, 0, 0, 0.638);
        color: white;
        border: none;
        cursor: pointer;
        margin: 0 20px;
        top: 63%;
        padding: 15px 15px;
        border-radius: 20%;
        font-size: 20px;
        user-select: none;
        z-index: 10;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        transition: 0.3s;
    }

    .arrow:hover {
        background: #007bff;
    }

    .left {
        left: -20px;
    }

    .right {
        right: -20px;
    }

    @media (max-width: 1340px) {
        padding: 10px;
        margin-top: 0px;

        h1 {
            font-size: 25px;
        }

        h2 {
            font-size: 18px;
        }

        .card-wrapper {
            gap: 15px;
        }

        .card {
            min-width: 300px;
            height: 180px;
            font-size: 18px;

            a img {
                width: 100%;
                min-width: 300px;
                height: 180px;
            }
        }

        .arrow {
            padding: 7px;
            border-radius: 20%;
            font-size: 20px;
            top: 67%;
        }

    }

    @media (max-width: 700px) {
        padding: 10px;

        h1 {
            font-size: 20px;
        }

        h2 {
            font-size: 16px;
        }

    }

}

.Constituency-content {

    .container {
        .scrolling {
            display: flex;
            gap: 10px;
            overflow-x: auto;
            white-space: nowrap;
            padding-bottom: 10px;
            // scroll-behavior: smooth; 

            /* Hide Scrollbar for Chrome, Safari */
            &::-webkit-scrollbar {
                display: none;
            }

            /* Hide Scrollbar for Firefox */
            scrollbar-width: none;
            -ms-overflow-style: none; // Hide scrollbar for IE & Edge

            img {
                width: 300px;
                height: 200px;
                border-radius: 10px;
                object-fit: cover;
                cursor: pointer;
                margin-top: 60px;
            }
        }

        /* Responsive Design */
        @media (max-width: 768px) {
            .scrolling img {
                width: 100%;
                /* Smaller images for tablets */
                he
            }
        }

        @media (max-width: 480px) {
            .scrolling img {
                width: 100%;
                /* Even smaller images for phones */
            }
        }
    }


    .course-heading {
        margin-bottom: -40px;
        margin-top: 10px;

        .videologo {
            width: 40px;
        }

        .videologo:hover {
            border-radius: 50%;
            box-shadow: 0px 0px 5px;
        }

    }

    .banner {
        padding-bottom: 40px;

        img {
            width: 100%;
            border-radius: 20px;
            box-shadow: 0px 0px 5px rgb(255, 195, 16);
        }

        .banner-text {
            h4 {
                font-size: 25px;
                font-weight: 600;
                color: #cbb05f;
                text-decoration: underline;
            }

            ul {
                width: 100%;

                li {
                    padding: 10px 0;
                    font-size: 18px;
                    width: 500px;
                    color: #4e4e4e;

                }
            }
        }

    }

    .bannertext {
        p {
            font-size: 18px;
            word-spacing: 5px;
            line-height: 30px;
        }

        #moreContent {
            display: none;
        }

        .read-more-btn {
            background-color: #ffbb00;
            color: black;
            border: none;
            padding: 10px 15px;
            cursor: pointer;
            margin-top: 10px;
            border-radius: 5px;
        }
    }

}



.jobroles {
    .grid {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        padding: 20px;
        justify-content: center;
    }

    .course-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 260px;
        height: auto;
        cursor: pointer;

        .image-wrapper {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 12px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 12px;
            }
                img:hover {
                transform: scale(1.07);
                transition: .5s;
            }

            .badge {
                position: absolute;
                top: 5px;
                right: 5px;
                width: 25px;
                height: 25px;
                background: #facc15;
                color: #000;
                font-weight: bold;
                padding: 4px 8px;
                border-radius: 50%;
                font-size: 0.8rem;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
                align-items: center;
                display: flex;
                justify-content: center;
            }
        }

        .button {
            margin-top: 8px;
            width: 100%;
            text-align: center;
            padding: 8px 12px;
            background: white;
            color: #333;
            border: 1px solid #ccc;
            border-radius: 8px;
            cursor: pointer;
            transition: background 0.3s ease;

            &:hover {
                background: linear-gradient(to right, rgba(250, 204, 21, 0.55), rgba(249, 116, 22, 0.53));
                color: white;
                border: none;
            }
        }
    }
}



`;